
import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, Image, TouchableOpacity, TextInput, ActivityIndicator  } from 'react-native';
import logo from './../assets/logo-psihomaestru-3.png'; 
import { Ionicons } from '@expo/vector-icons'; 


export default function ForgotPassword({navigation, route}) {

    const { urseremail } = route.params;
    const { tokenKey } = route.params;

    const [isLoading, setLoading] = useState(true);
    const [shouldShowMandatory, setShouldShowMandatory] = useState(false);
    const [shouldShowNotFound, setshouldShowNotFound] = useState(false);
    const [shouldShowReset, setshouldShowReset] = useState(false);


    //Post search method to find email utilizatori
    let [length, setLength] = useState();
    let [utilizatorID, setutilizatorID] = useState();
    const SearchEmailUtilizator = async  () => {
        try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/utilizator', {
            method:'POST',
            headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+tokenKey
            },
            body: JSON.stringify(
            {
                "useremail": email
            }
            )
        }
        )
        const json = await response.json();
        console.log(json);
        setLength(json.length);
            if(json.length >= 1) {
                setshouldShowNotFound(false);
                setutilizatorID(json[0].utilizatorID);
                SendEmail(json[0].utilizatorID);
            return;
            }
            setLoading(false);
            setshouldShowNotFound(true);
          } catch (error) {
        console.error(error);
        setLoading(false);
        } finally {
        setLoading(false);
        }
    };

    //Post send email link to reset password
    let [emailSent, setemailSent] = useState(false);
    const SendEmail = async  (utilizator) => {
        try {
        const response = await fetch('https://rupertapi.azurewebsites.net/api/ForgotPass', {
            method:'POST',
            headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+tokenKey
            },
            body: JSON.stringify(
                {
                    "ToEmail": email,
                    "utilizatorID": utilizator
                }
            )
        }
        )
        const json = await response.json();
        console.log(json);
        setemailSent(json.result.isSuccessStatusCode);
        setshouldShowReset(true);
          navigation.replace('Login',
              {
                tokenKey:tokenKey, 
              })
        setLoading(false);
        } catch (error) {
        console.error(error);
        setLoading(false);
        } finally {
        setLoading(false);
        }
    };

    let [email, setEmail] = useState('');
    const checkTextInput = () => {
        if (isValidEmail === false) {
            setShouldShowMandatory(true);
            return;
        } 
        setShouldShowMandatory(false);
        setLoading(true);
        SearchEmailUtilizator();
    }

    let [isValidEmail, setisValidEmail] = useState(false);
    const validate = (enteredemail) => {
        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(enteredemail).toLowerCase());
    }


    useEffect(() => {
        setEmail(urseremail);
        setShouldShowMandatory(false);
        setLoading(false);
      }, []);

      // console.log('emailSent:'+emailSent);
      // console.log('utilizatorID:'+utilizatorID);

    return (


        <View style={styles.container}>
            <Image style={styles.logo} source={logo} />
            <Text style={styles.MainText}>Introdu adresa de email</Text>
            <TextInput 
            name='email'
            style={styles.input}
            placeholder='ex: dorina@gmail.com'
            onChangeText={
                (val) => {setEmail(val);setisValidEmail(validate(val))}
            }
            />
            {shouldShowMandatory ? (
            <Text style={styles.inputMando}>Te rog sa completezi emailul in formatul corespunzator!</Text>
            ) : null
            }
            {shouldShowNotFound ? (
            <Text style={styles.inputMando}>Emailul nu a fost găsit in aplicatie, te rog verifică și încearcă din nou!</Text>
            ) : null
            }
            {shouldShowReset ? (
            <Text style={styles.inputMando}>Verifică emailul ca sa resetezi parola. După ce ai resetat parola te poți întoarce pe ecranul de logare!</Text>
            ) : null
            }

            {isLoading ? 
            ( 
              <ActivityIndicator size="large" color="#628914" style={{position: "absolute", top: 450, alignSelf: 'center', zIndex: 1, elevation: 1 }} />
            ) : (
            <TouchableOpacity
            style={styles.buttonPlay}
            onPress={() => {
                checkTextInput();
                }}
            >
            <Ionicons name="ios-mail-unread-outline" size={24} color="#628914" />
            </TouchableOpacity>
              )
            }
        </View>
    );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#e9ebee',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginBtn: {
    backgroundColor: '#EFEB88',
    position: 'absolute',
    top: 260,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  logoutBtn: {
    backgroundColor: '#EFEB88',
    position: "absolute",
    top: 400,
    alignSelf: 'center',
    width: 50,
    height: 50,
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  logo: {
    position: "absolute",
    alignSelf: 'flex-start',
    top: 30,
    left: 20,
    width: 200, 
    height: 50,
  },
  MainText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    position:"absolute",
    top:150,
  },
  MainText2: {
    fontSize: 14,
    fontWeight: 'bold',
    color: "#3E473A",
    flexShrink: 1,
    position:"absolute",
    top:340,
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    position:"absolute",
    top:180,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 200,
    borderRadius:25,
  },
  inputMando: {
    position:"absolute",
    top:400,
    color: 'red'
  },
  buttonPlay: {
    position: 'absolute',
    top:480,
    alignSelf: 'center',
    width: 50,
    height: 50,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  label1: {
    color: "#3E473A",
    fontSize: 14,
    top: 260,
    position: 'absolute',
  },
  Switch1: {
    top:250, 
    alignSelf: 'flex-start',
    position: 'absolute',
    left: 20,
  },
  label2: {
    color: "#3E473A",
    fontSize: 14,
    top: 310,
    position: 'absolute',
  },
  Switch2: {
    top:300, 
    alignSelf: 'flex-start',
    position: 'absolute',
    left: 20,
  },
  label3: {
    color: "#3E473A",
    fontSize: 14,
    top: 360,
    position: 'absolute',
  },
  Switch3: {
    top:350, 
    alignSelf: 'flex-start',
    position: 'absolute',
    left: 20,
  },
  hyperlinkStyle: {
    color: 'blue',
  },

});